/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { FetchGraphQL } from '@adobe-commerce/fetch-graphql';

/**
 * GraphQL client methods for making API requests.
 * Provides methods to configure endpoints, headers, and execute GraphQL queries.
 */
export const {
  /** Sets the GraphQL endpoint URL */
  setEndpoint,
  /** Sets a single GraphQL header */
  setFetchGraphQlHeader,
  /** Removes a GraphQL header */
  removeFetchGraphQlHeader,
  /** Sets multiple GraphQL headers at once */
  setFetchGraphQlHeaders,
  /** Executes a GraphQL query or mutation */
  fetchGraphQl,
  /** Gets the current configuration */
  getConfig,
} = new FetchGraphQL().getMethods();
